define.alias("checkout/components/seamless-checkout/checkout-modal", "calendar/components/seamless-checkout/checkout-modal");